import { module } from 'modujs';
import Isotope from 'isotope-layout';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";


export default class extends module {
    constructor(m) {
        super(m);
        this.events = { click: { 'pill': 'click' } };

    }
    init(){

        this.iso = new Isotope( this.$( 'items' )[0], { itemSelector: '[data-masonry-gallery-item]' });

        this.items = [...this.el.querySelectorAll( '[data-fancybox="gallery"]' )];

        this.galleryName = 'gallery-' + this.el.dataset.moduleMasonryGallery;

        this.items.forEach( item => item.dataset.fancybox = this.galleryName  );

        this.fancybox = Fancybox.bind( '[data-fancybox="' + this.galleryName + '"]', {
            Hash: false,
            width: 400,
            Navigation: {
                prevTpl:
                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M11 5l-7 7 7 7"/><path d="M4 12h16"/></svg>',
                nextTpl:
                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M4 12h16"/><path d="M13 5l7 7-7 7"/></svg>',
            },
            Toolbar: {
                display: {
                    left: [],
                    middle: [],
                    right: ["close"],
                },
            },
            Thumbs: false,


        });
    }

    click( e ){
        let active = e.currentTarget;

        if( active.classList.contains( 'active' ) ) return;
        active.parentNode.querySelector( '.active' ).classList.remove( 'active' );
        active.classList.add( 'active' );

        let filter = active.dataset.filterValue;


        this.iso.arrange({
            filter: ( el, itemElem ) => {

                let d = el || itemElem;
                return filter === 'ALL' ? true : d.dataset.filterValue === filter ;
            }
        });

        this.call( 'update', false, 'Scroll' );

    }


}
